var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { ParameterizedRemoteData } from "../Infra/RemoteData";
export class PatientPreferencesManager {
    constructor(authManager, patientService, invalidationManager) {
        this.authManager = authManager;
        this.patientService = patientService;
        this.invalidationManager = invalidationManager;
        this.preferences = new ParameterizedRemoteData(this.invalidationManager, () => [this.authManager.orgId, this.authManager.id, this.authManager.userType], () => this.loadPreferences());
    }
    async loadPreferences() {
        const userId = this.authManager.id;
        const userType = this.authManager.userType;
        if (userType === "PATIENT" && userId) {
            return await this.patientService.getPatientPreferences(userId);
        }
        else {
            return null;
        }
    }
    async updatePatientPreferences(preferences) {
        if (this.authManager.userType === "PATIENT" && this.authManager.orgId && this.authManager.id) {
            await this.patientService.updatePatientPreferences(this.authManager.orgId, this.authManager.id, preferences);
            await this.preferences.waitForReload();
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientPreferencesManager.prototype, "preferences", void 0);
